import { render } from "./AssignedClientUsers.vue?vue&type=template&id=5f3f06b7&ts=true"
import script from "./AssignedClientUsers.vue?vue&type=script&lang=ts"
export * from "./AssignedClientUsers.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__